import { render } from "./RDialog.vue?vue&type=template&id=369959e8&scoped=true"
import script from "./RDialog.vue?vue&type=script&lang=js"
export * from "./RDialog.vue?vue&type=script&lang=js"

import "./RDialog.vue?vue&type=style&index=0&id=369959e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369959e8"]])

export default __exports__